export enum ProductSaleType {
  UNIT = 'u',
  WEIGHT = 'w',
  UNIT_WEIGHT = 'uw',
  WEIGHT_UNIT = 'wu',
}
